export default class Locale_WorkPackageImportDto {
	StartGreaterThanTodayAndCurrentPeriod: string = "'Start' must be specified and greater than today/start of current period.";
	UseDateOnlyWhenShrinkingOrExtendingPeriod: string = "Use this date ONLY when you want to shrink/extend the template";
}